/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { c as t } from "./mat3f64.js";
import { a as s } from "./quatf64.js";
import { c as a, f as n } from "./vec3f64.js";
import { E as o, R as r } from "./common.js";
import { d as c, c as e, u, n as i } from "./vec3.js";
import { c as h, s as M, a as f, b as l, d as m, l as p, e as q, f as d, n as j, g, h as x } from "./vec4.js";

function A(t) {
  return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t;
}

function I(t, s, a) {
  a *= .5;
  var n = Math.sin(a);
  return t[0] = n * s[0], t[1] = n * s[1], t[2] = n * s[2], t[3] = Math.cos(a), t;
}

function P(t, s) {
  var a = 2 * Math.acos(s[3]),
      n = Math.sin(a / 2);
  return n > o ? (t[0] = s[0] / n, t[1] = s[1] / n, t[2] = s[2] / n) : (t[0] = 1, t[1] = 0, t[2] = 0), a;
}

function v(t, s, a) {
  var n = s[0],
      o = s[1],
      r = s[2],
      c = s[3],
      e = a[0],
      u = a[1],
      i = a[2],
      h = a[3];
  return t[0] = n * h + c * e + o * i - r * u, t[1] = o * h + c * u + r * e - n * i, t[2] = r * h + c * i + n * u - o * e, t[3] = c * h - n * e - o * u - r * i, t;
}

function b(t, s, a) {
  a *= .5;
  var n = s[0],
      o = s[1],
      r = s[2],
      c = s[3],
      e = Math.sin(a),
      u = Math.cos(a);
  return t[0] = n * u + c * e, t[1] = o * u + r * e, t[2] = r * u - o * e, t[3] = c * u - n * e, t;
}

function y(t, s, a) {
  a *= .5;
  var n = s[0],
      o = s[1],
      r = s[2],
      c = s[3],
      e = Math.sin(a),
      u = Math.cos(a);
  return t[0] = n * u - r * e, t[1] = o * u + c * e, t[2] = r * u + n * e, t[3] = c * u - o * e, t;
}

function E(t, s, a) {
  a *= .5;
  var n = s[0],
      o = s[1],
      r = s[2],
      c = s[3],
      e = Math.sin(a),
      u = Math.cos(a);
  return t[0] = n * u + o * e, t[1] = o * u - n * e, t[2] = r * u + c * e, t[3] = c * u - r * e, t;
}

function _(t, s) {
  var a = s[0],
      n = s[1],
      o = s[2];
  return t[0] = a, t[1] = n, t[2] = o, t[3] = Math.sqrt(Math.abs(1 - a * a - n * n - o * o)), t;
}

function z(t, s, a, n) {
  var r = s[0],
      c = s[1],
      e = s[2],
      u = s[3];
  var i,
      h,
      M,
      f,
      l,
      m = a[0],
      p = a[1],
      q = a[2],
      d = a[3];
  return h = r * m + c * p + e * q + u * d, h < 0 && (h = -h, m = -m, p = -p, q = -q, d = -d), 1 - h > o ? (i = Math.acos(h), M = Math.sin(i), f = Math.sin((1 - n) * i) / M, l = Math.sin(n * i) / M) : (f = 1 - n, l = n), t[0] = f * r + l * m, t[1] = f * c + l * p, t[2] = f * e + l * q, t[3] = f * u + l * d, t;
}

function L(t) {
  var s = r(),
      a = r(),
      n = r(),
      o = Math.sqrt(1 - s),
      c = Math.sqrt(s);
  return t[0] = o * Math.sin(2 * Math.PI * a), t[1] = o * Math.cos(2 * Math.PI * a), t[2] = c * Math.sin(2 * Math.PI * n), t[3] = c * Math.cos(2 * Math.PI * n), t;
}

function k(t, s) {
  var a = s[0],
      n = s[1],
      o = s[2],
      r = s[3],
      c = a * a + n * n + o * o + r * r,
      e = c ? 1 / c : 0;
  return t[0] = -a * e, t[1] = -n * e, t[2] = -o * e, t[3] = r * e, t;
}

function w(t, s) {
  return t[0] = -s[0], t[1] = -s[1], t[2] = -s[2], t[3] = s[3], t;
}

function B(t, s) {
  var a = s[0] + s[4] + s[8];
  var n;
  if (a > 0) n = Math.sqrt(a + 1), t[3] = .5 * n, n = .5 / n, t[0] = (s[5] - s[7]) * n, t[1] = (s[6] - s[2]) * n, t[2] = (s[1] - s[3]) * n;else {
    var _a = 0;
    s[4] > s[0] && (_a = 1), s[8] > s[3 * _a + _a] && (_a = 2);

    var _o = (_a + 1) % 3,
        _r = (_a + 2) % 3;

    n = Math.sqrt(s[3 * _a + _a] - s[3 * _o + _o] - s[3 * _r + _r] + 1), t[_a] = .5 * n, n = .5 / n, t[3] = (s[3 * _o + _r] - s[3 * _r + _o]) * n, t[_o] = (s[3 * _o + _a] + s[3 * _a + _o]) * n, t[_r] = (s[3 * _r + _a] + s[3 * _a + _r]) * n;
  }
  return t;
}

function C(t, s, a, n) {
  var o = .5 * Math.PI / 180;
  s *= o, a *= o, n *= o;
  var r = Math.sin(s),
      c = Math.cos(s),
      e = Math.sin(a),
      u = Math.cos(a),
      i = Math.sin(n),
      h = Math.cos(n);
  return t[0] = r * u * h - c * e * i, t[1] = c * e * h + r * u * i, t[2] = c * u * i - r * e * h, t[3] = c * u * h + r * e * i, t;
}

function D(t) {
  return "quat(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + t[3] + ")";
}

var F = h,
    G = M,
    O = f,
    R = v,
    T = l,
    W = m,
    X = p,
    Y = q,
    Z = Y,
    H = d,
    J = H,
    K = j,
    N = g,
    Q = x;

function S(t, s, a) {
  var n = c(s, a);
  return n < -.999999 ? (e(U, V, s), u(U) < 1e-6 && e(U, $, s), i(U, U), I(t, U, Math.PI), t) : n > .999999 ? (t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 1, t) : (e(U, s, a), t[0] = U[0], t[1] = U[1], t[2] = U[2], t[3] = 1 + n, K(t, t));
}

var U = a(),
    V = n(1, 0, 0),
    $ = n(0, 1, 0);

function tt(t, s, a, n, o, r) {
  return z(st, s, o, r), z(at, a, n, r), z(t, st, at, 2 * r * (1 - r)), t;
}

var st = s(),
    at = s();

function nt(t, s, a, n) {
  var o = ot;
  return o[0] = a[0], o[3] = a[1], o[6] = a[2], o[1] = n[0], o[4] = n[1], o[7] = n[2], o[2] = -s[0], o[5] = -s[1], o[8] = -s[2], K(t, B(t, o));
}

var ot = t(),
    rt = Object.freeze({
  __proto__: null,
  identity: A,
  setAxisAngle: I,
  getAxisAngle: P,
  multiply: v,
  rotateX: b,
  rotateY: y,
  rotateZ: E,
  calculateW: _,
  slerp: z,
  random: L,
  invert: k,
  conjugate: w,
  fromMat3: B,
  fromEuler: C,
  str: D,
  copy: F,
  set: G,
  add: O,
  mul: R,
  scale: T,
  dot: W,
  lerp: X,
  length: Y,
  len: Z,
  squaredLength: H,
  sqrLen: J,
  normalize: K,
  exactEquals: N,
  equals: Q,
  rotationTo: S,
  sqlerp: tt,
  setAxes: nt
});
export { X as A, Z as B, J as C, K as D, Q as E, tt as F, nt as G, F as a, b, w as c, y as d, E as e, W as f, P as g, H as h, k as i, N as j, C as k, Y as l, v as m, A as n, _ as o, z as p, rt as q, S as r, I as s, L as t, B as u, D as v, G as w, O as x, R as y, T as z };